import { VQGetCountriesKey } from '~/constants'
import type { CountryInterface, ResponseInterface } from '~/types'

export const useGetCountryListQuery = () => {
  return useQuery({
    queryKey: [VQGetCountriesKey],
    queryFn: () =>
      useRequest().get<ResponseInterface<CountryInterface[]>>(
        'miscellaneous/countries',
        {
          baseURL: useRuntimeConfig().public.baseUrl,
        },
      ),
    select: ({ data: { data } }) => data,
    refetchOnWindowFocus: false,
  })
}
